<template>
  <date-range-picker
    class="date-picker"
    opens="inline"
    v-bind:locale-data="this.$options.localeData"
    v-bind:ranges="false"
    v-bind:single-date-picker="isRange ? 'range' : 'single'"
    v-bind:auto-apply="true"
    v-model="dayRange"
    @start-selection="emitChangeDate($event)"
  />
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import dateMixin from '@/mixins/dateMixin';

/**
 * @description Название события изменения выбранного месяца.
 * @type {string}
 */
const NAME_EVENT_CHANGE_MONTH = 'change-month';

const localeData = {
  daysOfWeek: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
  monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  firstDay: 1,
};

/**
 * @description Компонент выбора даты по месяцу.
 * @type {Vue}
 */
export default {
  localeData,
  components: {
    DateRangePicker,
  },
  computed: {
    isRange: ({ range }) => !!range.to,
    dayRange: {
      get() {
        if (this.isRange) {
          return {
            startDate: this.range.from,
            endDate: this.range.to,
          };
        }
        return {
          startDate: this.isoDate,
        };
      },
      set(value) {
        if (value instanceof Object) {
          this.isoDate = value.startDate;
        } else {
          this.isoDate = value;
        }
      },
    },
  },
  data() {
    return {
      isoDate: this.value,
    };
  },
  methods: {
    /**
     * @description Отправить событие изменения месяца.
     * @param {string} value Месяц.
     * @returns {void}
     */
    emitChangeMonth(yearAndMonth) {
      this.$emit(NAME_EVENT_CHANGE_MONTH, yearAndMonth);
    },
    emitChangeDate(value) {
      this.isoDate = value;
    },
  },
  mixins: [
    dateMixin,
  ],
  name: 'DatePicker',
  props: {
    /**
     * @description Дата текущего дня.
     * @type {Date}
     */
    today: Date,
    /**
     * @description Значение выбранной даты.
     * @type {Date}
     */
    value: Date,
    /**
     * @description Период.
     */
    range: { type: [Object, Date], default: () => {} },
  },
  watch: {
    isoDate(updatedValue) {
      this.$emit('input', new Date(updatedValue));
    },
  },
};
</script>

<style lang="scss">
.date-picker {
  border-bottom: 1px solid #EAEFF3;
  width: 246px;
  margin: 0 auto 8px auto;
  .v-picker__body {
    width: 246px !important;
  }
  .v-date-picker-table {
    height: auto;
    padding: 0;
    th {
      font-weight: 400;
      font-size: 10px;
      &:nth-child(6n),
      &:nth-child(7n), {
        color: #EF474C;
      }
    }
  }
  .v-date-picker-header {
    background: #EAEFF3;
  }
  .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
    color: #0489E0;
  }
  .theme--light.v-date-picker-header .v-date-picker-header__value button:hover {
    color: #192A3E;
  }
  .theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-btn__loading, .theme--light.v-btn.v-btn--disabled .v-icon {
    color: #90A0B7 !important;
  }
  .v-date-picker-header__value button {
    padding: 5px 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }
  .v-btn--icon.v-size--default {
    height: 20px;
    width: 20px;
  }
  .theme--light.v-btn.v-btn--icon {
    color: transparent;
  }
  .theme--light.v-btn:hover:before {
    opacity: 0;
  }
  .mdi-chevron-left::before {
    content: '';
    background-image: url("@/assets/img/arrow/arrow-prev-grey.svg");
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #90A0B7;
    background-position: center;
    background-repeat: no-repeat;
  }
  .mdi-chevron-left:hover::before {
    background-image: url("@/assets/img/arrow/arrow-prev-blue.svg");
    border: 1px solid #0489E0;
  }
  .mdi-chevron-right::before {
    content: '';
    background-image: url("@/assets/img/arrow/arrow-next-grey.svg");
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #90A0B7;
    background-position: center;
    background-repeat: no-repeat;
  }
  .mdi-chevron-right:hover::before {
    background-image: url("@/assets/img/arrow/arrow-next-blue.svg");
    border: 1px solid #0489E0;
  }
  .v-btn--rounded {
    border-radius: 2px;
  }
  .v-date-picker-table--date .v-btn {
    height: 18px;
    width: 18px;
    font-weight: 400;
  }
  .theme--light.v-btn--active:before, .theme--light.v-btn--active:hover:before {
    opacity: 0;
  }
}
@media screen and (max-width: 480px) {
  .date-picker {
    width: 100%;
    .v-picker__body {
      width: 100% !important;
    }
  }
}

// Скрывает встроенный инпут пикера.
.reportrange-text {
  display: none;
}
.daterangepicker {
  margin-top: 0;
  border: none;
  .drp-calendar {
    width: auto;
    max-width: inherit;
  }
  .drp-calendar.left {
    padding: 0;
    width: 246px;
  }
  .calendar-table .next span,
  .calendar-table .prev span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #90A0B7;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(0);
  }
  .calendar-table .next span {
    background-image: url("@/assets/img/arrow/arrow-next-grey.svg");
  }
  .calendar-table .prev span {
    background-image: url("@/assets/img/arrow/arrow-prev-grey.svg");
  }
  th.month {
    color: #357ebd;
    font-size: 14px;

  }
}
@media (min-width: 564px) {
  .daterangepicker.ltr .drp-calendar.left .calendar-table {
    padding: 0;

  }
}
</style>
